import React, { useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  HStack,
  Divider,
  Box,
  Flex,
  Spacer,
} from "@chakra-ui/react";
import { formatAUDate, formatAUTime } from "../../global-client";
import { useDispatch, useSelector } from "react-redux";
import { getInvoice } from "../../redux/actions/invoiceActions";

const InvoiceModal = ({ isOpen, onClose, invSelectedRow, inv }) => {
  const dispatch = useDispatch();
  const { invoice } = useSelector((state) => state.invoice);

  useEffect(() => {
    if (inv && inv.INVOICE_ID) {
      dispatch(getInvoice(inv.INVOICE_ID));
    }
  }, [dispatch, inv]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Invoice Details</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>Invoice Number: {inv ? inv.INVOICE_NUM : "N/A"}</Text>
          {/* <Text>Invoice ID: {inv ? inv.INVOICE_ID : "N/A"}</Text> */}
          <HStack spacing={4}>
            <Text>Date: {inv ? formatAUDate(inv.INVOICE_DATE, { weekday: false }) : "N/A"}</Text>
            <Text>Time: {inv ? formatAUTime(inv.INVOICE_DATE) : "N/A"}</Text>
          </HStack>
          <Text>Job Number: {inv ? inv.JOB_NO : "N/A"}</Text>
          <Divider my={4} />
          {invoice && invoice.items && invoice.items.length > 0 && (
            <>
              <Text fontWeight='bold' mb={2}>
                Items:
              </Text>
              {invoice.items.map((item, index) => (
                <Box key={index}>
                  <HStack justifyContent='space-between' key={index}>
                    <Text>{item.PRODUCT_NAME}</Text>
                    <Text>{`$${item.TOTAL.toFixed(2)}`}</Text>
                  </HStack>
                  {((item.SERIAL !== "" && item.SERIAL !== "N/A" && item.SERIAL !== null) ||
                    (item.JOB_NO !== 0 && item.JOB_NO !== null)) && (
                    <Flex flexDirection='row' justify='space-between'>
                      {item.SERIAL !== "" && item.SERIAL !== "N/A" && item.SERIAL !== null && (
                        <Text ml='4' fontSize='sm'>
                          Serial: {item.SERIAL}
                        </Text>
                      )}
                      {item.JOB_NO !== 0 && item.JOB_NO !== null && (
                        <Text ml='4' fontSize='sm'>
                          Job# {item.JOB_NO}
                        </Text>
                      )}
                      <Spacer />
                    </Flex>
                  )}
                </Box>
              ))}
            </>
          )}
          <Divider my={4} />

          {inv && inv.TND_CASH !== 0 && (
            <HStack justifyContent='space-between'>
              <Text textAlign='right'>Cash:</Text>
              <Text> {`$${inv.TND_CASH.toFixed(2)}`}</Text>
            </HStack>
          )}
          {inv && inv.TND_CCARD !== 0 && (
            <HStack justifyContent='space-between'>
              <Text>Card:</Text>
              <Text> {`$${inv.TND_CCARD.toFixed(2)}`}</Text>
            </HStack>
          )}
          {inv && inv.TND_CHEQUE !== 0 && (
            <HStack justifyContent='space-between'>
              <Text>Cheque:</Text>
              <Text> {`$${inv.TND_CHEQUE.toFixed(2)}`}</Text>
            </HStack>
          )}
          {inv && inv.TND_BANK !== 0 && (
            <HStack justifyContent='space-between'>
              <Text>Bank:</Text>
              <Text> {`$${inv.TND_BANK.toFixed(2)}`}</Text>
            </HStack>
          )}
          {inv && inv.TND_MOTO !== 0 && (
            <HStack justifyContent='space-between'>
              <Text>MOTO:</Text>
              <Text> {`$${inv.TND_MOTO.toFixed(2)}`}</Text>
            </HStack>
          )}
          <Divider my={4} />
          <HStack justifyContent='space-between' fontWeight='bold'>
            <Text mr='20px'>Total:</Text>
            <Text textAlign='right'>{inv ? `$${inv.TOTAL.toFixed(2)}` : "N/A"}</Text>
          </HStack>
          <Divider my={4} />
        </ModalBody>

        <ModalFooter>
          <Button colorScheme='blue' mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default InvoiceModal;
